




























































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { Component } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { SetHelpContentIdPayload } from '@/core/core.store';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import { MswAppTitle } from '@/shared/msw-app-title';
import { SwTable, TableColumnConfig, ColumnSortRequestData, SortedColumnInfo, TableEntrySelectingEventData, TableData } from '@libs-uuif/shared/sw-table';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwExpandableTextfield, SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { InfoState } from '@/core';
import ExportcsvService from '@/shared/msw-exportcsv.service';
import { PageTitleConfig } from '../../../shared/msw-app-title/type';
const cssPrefix = 'mswProductClaims';

@Component({
  components: {
    ...UUIFComponents,
    MswAppTitle,
    SwTable,
    SwDropMenu,
    SwIconButton,
    SwIcon,
    SwExpandableTextfield,
    SwTextfield,
  },
})

export default class MswProductClaims extends SwExtendedVue {
  cssPrefix = cssPrefix;
  menuOpened: boolean = false;

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;
  search: string = '';
  textExpanded: boolean = false;
  appliedFilter: any = [];
  showFilterSearch : boolean = false;
  filterSearch: string = '';
  showSearchedTextInHeader : boolean = false;
  sortedColumns: SortedColumnInfo[] = [];
  selectedTableRows:any[] = [];
  tableData: TableData[] = []; // For table data
  tempTableData: TableData[] = []; // For duplicate table data
  productClaimsColConfig: TableColumnConfig[] = this.tableColConfigArr(); // Table Column Configuration
  tableColConfigArr(): TableColumnConfig[] {
    return [
      {
        key: 'customer',
        dataKey: 'customer',
        title: this.$t('productClaims.customer')
        .toString(),
        sorter: true,
        width: 200,
      },
      {
        key: 'contact',
        dataKey: 'contact',
        title: this.$t('quote.contact')
        .toString(),
      },
      {
        key: 'phone',
        dataKey: 'phone',
        title: this.$t('support.phone')
        .toString(),
      },
      {
        key: 'email',
        dataKey: 'email',
        title: this.$t('support.email')
        .toString(),
      },
      {
        key: 'hwsku',
        dataKey: 'hwsku',
        title: this.$t('productClaims.hardwareSKU')
        .toString(),
        width: 150,
      },
      {
        key: 'hwdesc',
        dataKey: 'hwdesc',
        title: this.$t('quote.description')
        .toString(),
        width: 150,
      },
      {
        key: 'hwserial',
        dataKey: 'hwserial',
        title: this.$t('products.serialnumber')
        .toString(),
        width: 150,
      },
      {
        key: 'hwfriendly',
        dataKey: 'hwfriendly',
        title: this.$t('products.friendlyName')
        .toString(),
        width: 150,
      },
      {
        key: 'servsku',
        dataKey: 'servsku',
        title: this.$t('productClaims.serviceSKU')
        .toString(),
      },
      {
        key: 'servdesc',
        dataKey: 'servdesc',
        title: this.$t('productClaims.serviceDescription')
        .toString(),
        width: 150,
      },
      {
        key: 'dtservexp',
        dataKey: 'dtservexp',
        title: this.$t('productClaims.serviceExpiry')
        .toString(),
        width: 150,
      },
      {
        key: 'add1',
        dataKey: 'add1',
        title: this.$t('productClaims.address1')
        .toString(),
      },
      {
        key: 'add2',
        dataKey: 'add2',
        title: this.$t('productClaims.address2')
        .toString(),
      },
      {
        key: 'city',
        dataKey: 'city',
        title: this.$t('signup.city')
        .toString(),
      },
      {
        key: 'state',
        dataKey: 'state',
        title: this.$t('signup.state')
        .toString(),
      },
      {
        key: 'province',
        dataKey: 'province',
        title: this.$t('signup.province')
        .toString(),
      },
      {
        key: 'rnwloption',
        dataKey: 'rnwloption',
        title: this.$t('productClaims.renewalOption')
        .toString(),
        width: 150,
      },
    ];
  }
  // For Filter menu items
  get filterItems(): DropMenuItem[] {
    return [
      {
        id: 'customer',
        content: this.$t('productClaims.customer')
        .toString(),
      },
      {
        id: 'contact',
        content: this.$t('quote.contact')
        .toString(),
      },
      {
        id: 'phone',
        content: this.$t('support.phone')
        .toString(),
      },
      {
        id: 'email',
        content: this.$t('support.email')
        .toString(),
      },
      {
        id: 'hwsku',
        content: this.$t('productClaims.hardwareSKU')
        .toString(),
      },
      {
        id: 'hwdesc',
        content: this.$t('quote.description')
        .toString(),
      },
      {
        id: 'hwserial',
        content: this.$t('products.serialnumber')
        .toString(),
      },
      {
        id: 'hwfriendly',
        content: this.$t('products.friendlyName')
        .toString(),
      },
      {
        id: 'servsku',
        content: this.$t('productClaims.serviceSKU')
        .toString(),
      },
      {
        id: 'servdesc',
        content: this.$t('productClaims.serviceDescription')
        .toString(),
      },
      {
        id: 'dtservexp',
        content: this.$t('productClaims.serviceExpiry')
        .toString(),
      },
      {
        id: 'add1',
        content: this.$t('productClaims.address1')
        .toString(),
      },
      {
        id: 'add2',
        content: this.$t('productClaims.address2')
        .toString(),
      },
      {
        id: 'city',
        content: this.$t('signup.city')
        .toString(),
      },
      {
        id: 'state',
        content: this.$t('signup.state')
        .toString(),
      },
      {
        id: 'province',
        content: this.$t('signup.province')
        .toString(),
      },
      {
        id: 'rnwloption',
        content: this.$t('productClaims.renewalOption')
        .toString(),
      },
    ];
  }

  getProductClaimsData() {
    this.$store.dispatch('MswProductClaimsModule/getClaimsReport')
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp.operationStatus === 'OK') {
          console.warn(resp.content.Records);
          const rclaims = resp.content.Records;
          this.tableData = rclaims;
          // this.tableData = [];
          this.tableData.map((item: any, index: number) => {
            item['_key'] = index + 1;
          });
          // console.warn('tabledata', this.tableData);
          this.tempTableData = this.tableData;
        // console.warn(this.paginationConfig.pageNumber);
        }
      });
  }
  // Getting claims Data and formating ends

  // For title of the page
  get getHeaderConfig(): PageTitleConfig {
    return {
      pageTitle: this.$t('browserTitles.productClaims')
      .toString(),
      pageParentName: this.$t('products.reports')
      .toString(),
      isFetchFromProps: true,
    };
  }

  // Filter Iplementation starts
  onFilterClick(filterItem : any) {
    this.menuOpened = false;
    let removeIndex : number = -1;
    this.filterItems.forEach((element: any, i: number) => {
      if (element.id === filterItem) {
        removeIndex = i;
      }
    });
    if (removeIndex !== -1) {
      this.appliedFilter.push(
        {
          id: this.filterItems[removeIndex].id,
          content: this.filterItems[removeIndex].content,
          value: '',
        });
      this.filterSearch = '';
      this.showFilterSearch = true;
    }
  }
  initiateFilter(event : any, filterId : number) {
    if (event.keyCode === 13) {
      if (filterId === undefined) {
        this.applyFilter();
      } else {
        this.setFilterValue(event, filterId);
      }
    }
  }
  setFilterValue(event = undefined, index: number) {
    if (event !== undefined && this.filterSearch === '') {
      this.removeFilterBox(index);
    } else {
      this.appliedFilter.forEach((element : any, i : number) => {
        if (i === index) {
          if (event !== undefined) {
            element.value = this.filterSearch;
            this.showFilterSearch = false;
          }
        }
      });
      this.applyFilter();
    }
  }
  applyFilter(isExternal: boolean = false) {
    if (!isExternal) {
      this.tableData = this.tempTableData;
    }
    if (this.appliedFilter.length > 0) {
      this.appliedFilter.forEach((element : any) => {
        this.tableData = this.tableData.filter((order : any) => {
          const elementValueArray = element.value.split(',');
          const srcValue = order[element.id].toUpperCase();
          let flag = 0;
          elementValueArray.every((elementValue : any) => {
            if (srcValue.indexOf(elementValue.trim()
            .toUpperCase()) >= 0) {
              flag = 1;
              return false;
            }
            if (srcValue.indexOf(elementValue.trim()
            .toUpperCase()) < 0) {
              return true;
            }
          });
          if (flag === 1) {
            return true;
          }
        });
      });
    }
    if (this.search !== '') {
      this.textExpanded = false;
      const key : string = this.search.toUpperCase();
      let flag : number = 0;
      const searchKeys = ['customer', 'contact', 'phone', 'email', 'hwsku', 'hwdesc', 'hwserial', 'hwfriendly', 'servsku',
        'servdesc', 'dtservexp', 'add1', 'add2', 'city', 'state', 'province', 'rnwloption'];
      this.tableData = this.tableData.filter((item : any) => {
        flag = 0;
        searchKeys.forEach((field) => {
          if (item[field] && (item[field].toUpperCase()).indexOf(key) >= 0) {
            flag = 1;
            return false;
          }
          if (item[field] && (item[field].toUpperCase()).indexOf(key) < 0) {
            return true;
          }
        });
        if (flag === 1) {
          return true;
        }
      });
      this.showSearchedTextInHeader = true;
    }
    // this.ProductClaims;
  }
  removeFilterBox(id: number) {
    let removeIndex = -1;
    this.filterSearch = '';
    this.appliedFilter.forEach((element : any, i : number) => {
      if (element.id === id) {
        element.value = '';
        removeIndex = i;
      }
    });
    this.appliedFilter.splice(removeIndex, 1);
    this.applyFilter();
  }
  clearAllFilters() {
    this.appliedFilter.forEach((element : any) => {
      element.value = '';
    });
    this.appliedFilter = [];
    this.search = '';
    this.showFilterSearch = false;
    this.applyFilter();
  }
  clearFilter() {
    this.search = '';
    this.showSearchedTextInHeader = false;
    this.applyFilter();
  }
  // Filter Iplementation ends

  // For ting the rows
  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  // On selection of table rows
  onEntrySelecting(data: TableEntrySelectingEventData) {
    const selectedKey: any = data.entryKey;
    if (data.selecting) {
      this.selectedTableRows.push((this.tableData[Number(selectedKey)]));
    } else {
      const arrIndexes = this.selectedTableRows.map((user) => { return user._key; });
      const removeIndex = arrIndexes.indexOf(Number(selectedKey));
      this.selectedTableRows.splice(removeIndex, 1);
    }
    console.warn(this.selectedTableRows);
  }

  exportToCSV() {
    ExportcsvService.startExport(this.mapToExport(this.tableData), 'Report.csv');
  }
  mapToExport(tableData : any) {
    const tableDataFitered : any[] = [];
    tableData.forEach((object : any) => {
      const obj : any = {};
      this.filterItems.forEach((ele : any) => {
        obj[`${ele.content}`] = object[`${ele.id}`];
      });
      tableDataFitered.push(obj);
    });
    return tableDataFitered;
  }

  created() {
    this.setHelpContentId({ helpId: ['product-claims'] });
    this.getProductClaimsData();
  }

  // For toaster message
  showMessage(infoType: string, infoMsg: string): void {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    this.$store.commit('displayMessage', message);
  }

}
